module.exports = __webpack_public_path__ + "img/slide-31.95ef0355.jpg";